import {BuilderTabIds} from "../../../constants";

export default {
    computed: {
        /**
         * @returns {String} The selected tab id or undefined when tabs have not yet been loaded
         */
        currentTabId(){
 
            //Certain tabs crash when rendered without an audience being present
            //having an audienceId should serve as an indicator for that
            const audienceId = this.$store.state.audienceManager.builder.audienceId;
            
            if(!audienceId){
                return;
            }
            
            const sortedTabs = this.$store.getters['audienceManager/builder/sortedTabs'];
            
            //If our route contains a TabId; we're on a question tab
            //otherwise we're on a special page with it's tabId embedded in its route meta
            const routeParams = this.$route.params;
            if(Reflect.has(routeParams, 'tabId')) {
                
                if(!sortedTabs.length && routeParams.tabId != BuilderTabIds.OVERVIEW) {
                    return BuilderTabIds.QUICKSTART;
                }

                return routeParams.tabId || sortedTabs[0].id;
            }
            return this.$route.meta.tabId;
        }
    }
};
